"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var processLogout = function processLogout() {
  sessionStorage.removeItem('auth.accessToken');
  sessionStorage.removeItem('auth.refreshToken');
};

var _default = processLogout;
exports.default = _default;